<div class="row filter-row">
  <div class="col-lg-12">
    <label class="text-primary font-weight-bold">STATUS</label>
    <mat-checkbox class="d-block" *ngFor="let status of statusOptions" [(ngModel)]="status.selected"
      (change)="updateStatus(status.option, $event)">
      {{ status.option }}
    </mat-checkbox>

    <mat-checkbox class="d-block" *ngFor="let destination of destinationsOptions" [(ngModel)]="destination.selected"
      (change)="updateDestination(destination.option, $event)">
      Comprado para {{ destination.option }}
    </mat-checkbox>
  </div>
  <div class="col-lg-12 mt-2">
    <mat-form-field>
      <mat-label>PERÍODO</mat-label>
      <input
        matInput
        type="text"
        name="daterangeInput"
        class="date-range input-text"
        ngxDaterangepickerBootstrap
        [(ngModel)]="selectedDateRange"
        [ranges]="ranges"
        [dateLimit]="365"
        [alwaysShowCalendars]="true"
        [showCustomRangeLabel]="false"
        [showCancel]="true"
        [showDropdowns]="true"
        [autoApply]="false"
        [linkedCalendars]="true"
        (datesUpdated)="selectedDate($event)"
      />
      @if (hasPeriodSelected) {
        <mat-icon
          matSuffix
          class="period-clear-icon"
          (click)="clearPeriodRange(); $event.stopPropagation()"
        >close</mat-icon>
      }
    </mat-form-field>
  </div>
  <div class="col-lg-12 mt-2">
    <mat-form-field>
      <mat-label class="mat-label-class">BUSCAR VEÍCULO</mat-label>
      <input matInput [(ngModel)]="filter.searchQuery" (keydown.enter)="onSearchEnter($event); false"
        (blur)="submitFilter()" />
      <mat-icon matSuffix (click)="submitFilter()" class="cursor-pointer">search</mat-icon>
    </mat-form-field>
  </div>

  <div class="col-lg-12 mt-4">
    <label class="text-primary font-weight-bold">TIPO DE VEÍCULO</label>
    <div class="row pr-3 d-flex justify-content-between mt-2">
      <div class="col-4 col-md-4" *ngFor="let segment of allSegments">
        <div class="card text-center card-type-vehicle-filter"
          [ngClass]="{'selected': filter.segments && filter.segments.indexOf(segment.segment) >= 0}"
          (click)="changeSegment(segment.segment)">
          <i class="d-block mx-auto text-primary cursor-pointer" [ngClass]="segment.iconClass"></i>
          {{segment.segmentLabel}}
        </div>
      </div>
    </div>
  </div>

  <div class="col-lg-12 mt-2">
    <mat-form-field>
      <mat-label>UNIDADE</mat-label>
      <input type="text" matInput [formControl]="evalDealerControl" [matAutocomplete]="evalDealerAutoComplete"
        (keydown.enter)="checkResetEvalDealer()" />
      <mat-autocomplete #evalDealerAutoComplete="matAutocomplete"
        (optionSelected)="selectEvalDealer($event.option.value)">
        @for (option of evalDealerOptions | async; track option.id) {
        <mat-option [value]="option">
            {{ option.name }}
          </mat-option>
        }
      </mat-autocomplete>
    </mat-form-field>
  </div>

  @if (canShowPricingUserFilter() && pricingUserOptions?.length > 0) {
  <div class="col-lg-12 mt-4">
    <mat-form-field style="width: 100%;">
      <mat-label>PRECIFICADOR</mat-label>
      <mat-select [formControl]="pricingUserControl" multiple (closed)="applyPricingUserFilter()">
        @for (user of pricingUserOptions; track user.id) {
          <mat-option [value]="user.id">
            {{ user.name }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
  </div>
  }

  @if (canShowPricingUserFilter() && filter.pricingUserIds?.length) {
  <div class="col-md-12">
    <mat-chip-listbox>
      @for (userId of filter.pricingUserIds; track userId) {
        <mat-chip-option [selectable]="false" [removable]="true" (removed)="removePricingUser(userId)">
          {{ getPricingUserName(userId) }}
          <mat-icon matChipRemove>cancel</mat-icon>
        </mat-chip-option>
      }
    </mat-chip-listbox>
  </div>
  }

  <div class="col-lg-12 mt-4">
    <label class="text-primary font-weight-bold">TIPO</label>
    <mat-checkbox class="d-block" *ngFor="let type of allEvalTypes" [checked]="isTypeSelected(type)"
      (change)="toggleType(type)">
      {{getEvalTypeLabel(type)}}
    </mat-checkbox>
  </div>

  <div class="col-lg-12 mt-4">
    <label class="text-primary font-weight-bold">TIPO DE PROPRIETÁRIO</label>
    <mat-checkbox class="d-block" *ngFor="let type of allOwnerTypes" [checked]="isOwnerTypeSelected(type)"
      (change)="toggleOwnerType(type)">
      {{getOwnerTypeLabel(type)}}
    </mat-checkbox>
  </div>

  <div class="col-lg-12 mt-4" *ngIf="canViewArchivedEvaluations()">
    <label class="text-primary font-weight-bold">Motivo do arquivamento</label>
    <mat-checkbox class="d-block" *ngFor="let reason of allReasonArchive" [checked]="isReasonArchiveSelected(reason)"
      (change)="toggleReasonArchive(reason)">
      {{getReasonArchiveLabel(reason)}}
    </mat-checkbox>
  </div>

  @if (userInfo()?.isAdmin()) {
    <div class="col-lg-12 mt-4">
      <label class="text-primary font-weight-bold">INTEGRAÇÃO</label>
      <mat-checkbox class="d-block" [(ngModel)]="filter.hasIntegrationError" (change)="submitFilter()">
        Com erro
      </mat-checkbox>
    </div>
  }
</div>